










import { GridItem } from '@/types';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  props: {
    cellClass: {
      type: String,
      default: '',
    },

    item: {
      type: Object as PropType<GridItem>,
      default: undefined,
    },

    toggle: {
      type: Function as PropType<(cell: GridItem) => void>,
      default: () => () => undefined,
    },

    size: {
      type: Object as PropType<Record<string, string>>,
      default: undefined,
    },

    aspectRatio: {
      type: Number,
      default: 1,
    },
  },
});
